/**
 * One copy per cart (theme setting "Limit each product to one per cart").
 *
 * The product form already refuses a second copy and the cart hides its quantity pickers.
 * This catches the paths that skip both, such as a cart link shared with a quantity in it:
 * any line holding more than one is set back to one, then the page reloads to show it.
 */
async function limitOnePerCart() {
  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;

    const cart = await response.json();
    /** @type {Record<string, number>} */
    const updates = {};
    for (const item of cart.items ?? []) {
      if (item.quantity > 1) updates[item.key] = 1;
    }
    if (Object.keys(updates).length === 0) return;

    const update = await fetch(`${Theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (update.ok) window.location.reload();
  } catch (error) {
    console.warn('[limit-one-per-cart] Could not check the cart:', error);
  }
}

limitOnePerCart();
